import actions from './actions'
import mutations from './mutation'

const state = {
  //当前订阅区块链的chainCid
  chainId: ''
}

export default {
  state,
  actions,
  mutations
}
